import Fetch from "./index";

export const getEvoCRMIntegration = async (assistantID) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch("/assistant/" + assistantID + "/evo-crm")
}

export const getEvoCRMPanelsIntegration = async (assistantID, id) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch("/assistant/" + assistantID + "/evo-crm/" + id + "/panels")
}

export const createEvoCRMIntegration = async (assistantID, body) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch(
    "/assistant/" + assistantID + '/evo-crm/',
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}

export const deleteEvoCRMIntegration = async (assistantID, id) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch(
    "/assistant/" + assistantID + '/evo-crm/' + id,
    {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}

export const updateEvoCRMIntegration = async (assistantID, id, body) => {
  if (!assistantID)
    return Promise.reject("failed to read id");

  return Fetch(
    "/assistant/" + assistantID + '/evo-crm/' + id,
    {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      }
    },
  )
}
